import * as React from "react";
import SelectBuyer from "../../SelectBuyer/SelectBuyer";
import SelectTeam from "../../SelectTeam-new/SelectTeam";
import SelectAgent from "../../SelectAgent/SelectAgent";
import SelectFirm from "../../SelectFirm/SelectFirm";
import OpenInCrmButton from "../../OpenInCrmButton/OpenInCrmButton";
import CommissionAgreementForm from "./CommissionAgreementForm";
import { AGENTS } from "../../../consts/tables";
import { getData } from "../../../requests/CRUD";
import { summitFirmId } from "../../../consts/env";
import { isFieldLocked } from "../../../access-levels";

const SUMMIT_FIRM_ID = summitFirmId;

const BuysideAgent = ({data, handleChangeDropdown, handleChangeInput, addNewItem, newFirm, newAgent, newBuyer, viewMode, deleted, isFinancing, isSnapshot, locks}) => {

    const handleSyncFirmBuyerAgent1 = () => {
        handleChangeDropdown(
            { BUYER_AGENT_4_FIRM: SUMMIT_FIRM_ID },
            undefined,
            undefined,
            "BUYER_AGENT_4_FIRM"
        );
    };

    const handleSyncFirmOutsideAgent = () => {
        const agentId = data.BUYER_AGENT_4;
        if (!agentId) return;
        const options = {
            column: ["ARCIMEDES_ROW_ID", "FIRM"],
            limit: { count: 1 },
            filter: [{ code: "ARCIMEDES_ROW_ID", text: String(agentId), type: "equal" }],
            filterType: "and",
        };
        getData({ tableCode: AGENTS, options }).then((res) => {
            if (res.success && res.data && res.data.length && res.data[0].FIRM != null && res.data[0].FIRM !== "") {
                handleChangeDropdown(
                    { BUYER_AGENT_4_FIRM: res.data[0].FIRM },
                    undefined,
                    undefined,
                    "BUYER_AGENT_4_FIRM"
                );
            }
        });
    };

    return (
        <div className="Buyside-agent">
            <div className="Buyside-agent_column">
                <SelectBuyer
                    className="Buyside-agent_column_item"
                    isFromProperty
                    value={data.BUYER_ID}
                    valueKey="BUYER_ID"
                    label="Buyer"
                    data={data}
                    handleParentChange={handleChangeDropdown}
                    withAddNew
                    addNewItem={addNewItem}
                    viewMode={viewMode}
                    deleted={deleted}
                    newBuyer={newBuyer}
                    viewModeExtra={data.BUYER_LEAD_ID ? <OpenInCrmButton leadId={data.BUYER_LEAD_ID} variant="link" /> : null}
                />
                <div className="Buyside-agent_column_item" style={{ position: 'relative', display: 'flex', flexDirection: 'row', alignItems: 'flex-end', gap: '12px' }}>
                    <div style={{ flex: 1, minWidth: 0}}>
                        <SelectTeam
                            isFromProperty
                            value={data.BUYER_AGENT_1}
                            valueKey="BUYER_AGENT_1"
                            percentKey="BUYER_AGENT_1_PERCENT"
                            percentDisabled={isFieldLocked(locks, "BUYER_AGENT_1_PERCENT")}
                            label="Buyer Agent 1"
                            data={data}
                            hasAgentPercent
                            handleParentChange={handleChangeDropdown}
                            handleInputParentChange={handleChangeInput}
                            viewMode={viewMode}
                            deleted={deleted}
                            onlySummitAgents
                        />
                    </div>
                    {data.BUYER_AGENT_1 && <button type="button" className="button-new text" style={{ color: '#90b9ed', flexShrink: 0, position: 'absolute', right: 0, bottom: "-8px" }} onClick={handleSyncFirmBuyerAgent1}>SYNC FIRM</button>}
                </div>
                <SelectTeam
                    className="Buyside-agent_column_item"
                    isFromProperty
                    value={data.BUYER_AGENT_2}
                    valueKey="BUYER_AGENT_2"
                    percentKey="BUYER_AGENT_2_PERCENT"
                    percentDisabled={isFieldLocked(locks, "BUYER_AGENT_2_PERCENT")}
                    label="Buyer Agent 2"
                    data={data}
                    hasAgentPercent
                    handleParentChange={handleChangeDropdown}
                    handleInputParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    onlySummitAgents
                />
                {
                    !isFinancing &&
                    <SelectTeam
                        className="Buyside-agent_column_item"
                        isFromProperty
                        value={data.BUYER_AGENT_3}
                        valueKey="BUYER_AGENT_3"
                        percentKey="BUYER_AGENT_3_PERCENT"
                        percentDisabled={isFieldLocked(locks, "BUYER_AGENT_3_PERCENT")}
                        label="Buyer Agent 3"
                        data={data}
                        hasAgentPercent
                        handleParentChange={handleChangeDropdown}
                        handleInputParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                        onlySummitAgents
                    />
                }
                <div className="Buyside-agent_column_item" style={{ position: 'relative' }}>
                    <SelectAgent
                        isFromProperty
                        value={data.BUYER_AGENT_4}
                        valueKey="BUYER_AGENT_4"
                        percentKey="BUYER_AGENT_4_PERCENT"
                        percentDisabled={isFieldLocked(locks, "BUYER_AGENT_4_PERCENT")}
                        label="Outside Agent"
                        data={data}
                        hasAgentPercent
                        handleParentChange={handleChangeDropdown}
                        handleInputParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                        withAddNew
                        addNewItem={addNewItem}
                        newAgent={newAgent}
                        viewModeExtra={data.BUYER_AGENT_4_LEAD_ID ? <OpenInCrmButton leadId={data.BUYER_AGENT_4_LEAD_ID} variant="link" /> : null}
                    />
                    {data.BUYER_AGENT_4 && <button type="button" className="button-new text" style={{ color: '#90b9ed', position: 'absolute', right: 0, bottom: "-8px" }} onClick={handleSyncFirmOutsideAgent}>SYNC FIRM</button>}
                </div> 
                <SelectFirm
                    className="Buyside-agent_column_item"
                    isFromProperty
                    value={data.BUYER_AGENT_4_FIRM}
                    valueKey="BUYER_AGENT_4_FIRM"
                    label="Buyer Agent Firm"
                    data={data}
                    handleParentChange={handleChangeDropdown}
                    withAddNew
                    addNewItem={addNewItem}
                    viewMode={viewMode}
                    deleted={deleted}
                    newFirm={newFirm}
                />
                {
                    // The agreement is generated from the record as it stands, so
                    // it has no place on a history snapshot of an earlier version.
                    !isSnapshot &&
                    <CommissionAgreementForm data={data} deleted={deleted} />
                }
            </div>
            <div className="Buyside-agent_column">
                <div className="Buyside-agent_column_item"></div>
                <div className="Buyside-agent_column_item"></div>
                <div className="Buyside-agent_column_item"></div>
                <div className="Buyside-agent_column_item"></div>
                <SelectAgent
                    className="Buyside-agent_column_item"
                    isFromProperty
                    value={data.REFERRING_BUYER_AGENT}
                    valueKey="REFERRING_BUYER_AGENT"
                    percentKey="REFERRING_BUYER_AGENT_PERCENT"
                    percentDisabled={isFieldLocked(locks, "REFERRING_BUYER_AGENT_PERCENT")}
                    label="Referring Agent"
                    data={data}
                    hasAgentPercent
                    handleParentChange={handleChangeDropdown}
                    handleInputParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    withAddNew
                    addNewItem={addNewItem}
                    newAgent={newAgent}
                />
                <SelectFirm
                    className="Listing-agent_column_item"
                    isFromProperty
                    value={data.REFERRING_BUYER_AGENT_FIRM}
                    valueKey="REFERRING_BUYER_AGENT_FIRM"
                    label="Referring Agent Firm"
                    data={data}
                    handleParentChange={handleChangeDropdown}
                    withAddNew={true}
                    addNewItem={addNewItem}
                    viewMode={viewMode}
                    deleted={deleted}
                    newFirm={newFirm}
                />
            </div>
        </div>
    );
};

export default BuysideAgent;